export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL, // 'https://app-cropconnect-dev-weu-001.azurewebsites.net',
  RSS_URL: process.env.REACT_APP_RSS_URL, // 'https://apim-gdb-dev.azure-api.net/api/news/rss/nordzucker',
  RSS_PL_URL: process.env.REACT_APP_RSS_PL_URL, // 'https://apim-gdb-dev.azure-api.net/api/news/rss_pl',
  API_AUTH_SCOPE: process.env.REACT_APP_CLIENT_ID, // '7d0a5556-666c-4d72-8c86-ddd9c419af21',
  APP_INSIGHTS_INSTRUMENTATION_KEY:
    process.env.REACT_APP_INSIGHTS_INSTRUMENTATION_KEY,
};
